import React, { useContext, Fragment, useState } from 'react';
import Traductor from '../Traductor';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import Button from '../bronson/Button';
import { withCookies } from 'react-cookie';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import DealerReceptorDecisions from '../dealerReceptor/DealerReceptorDecisions';
import Globals from '../../Globals';
import { delegate } from 'tippy.js';
const VehicleDealerReceptorModality = ({
    history,
    vehicleParent,
    loadingRequest,
    disabled,
    options,
}) => {
    const t = new Traductor();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const [isDetailView] = useState(options.type === 'detailvehicle');
    const [decisionsModal, setDecisionsModal] = useState(false);

    const printButton = () => {
        let buttonText = '';
        let className = '';
        let disabledButton = loadingRequest || disabled;
        let clickFunction = '';

        //RepurchaseObligation
        //0 = significa que tiene penalizacion, mostramos el campo RepurchaseObligationPrice
        //1 = Compromiso de compra irrevocable pero solo si es concesionario receptor igual al de devolucion
        //y 2  = ----- como una sin penaliacio y sin irrevocable. Solamente precio y decision abierta
        if (
            vehicleParent.RepurchaseObligation === 0 ||
            vehicleParent.RepurchaseObligation === 2 ||
            vehicleParent.IsReturnDealerPromoter == 0
        ) {
            buttonText = t.getTraduction('TakeADecision');
            //className = 'c-btn--secondary';
            clickFunction = openTakeDecision;
        } else if (vehicleParent.RepurchaseObligation === 1) {
            buttonText = t.getTraduction('Buy');
            clickFunction = directPurchase;
        }

        if (buttonText === '' && !vehicleParent.skeleton) return null;

        let options = {
            //id: "",
            text: buttonText,
            class:
                'c-vehicle-card__bottom-button ' +
                (isDetailView ? '' : ' c-btn--full ') +
                className,
            disabled: disabledButton,
        };

        return <Button options={options} onClick={clickFunction}></Button>;
    };

    const directPurchase = () => {
        setSelectedVehicle(vehicleParent);
        history.push(Globals.APPLICATION_PATH.DIRECT_PURCHASE);
    };

    const openTakeDecision = () => {
        setSelectedVehicle(vehicleParent);
        setDecisionsModal(true);

        delegate('#root', {
            target: '[data-tippy-content]',
            allowHTML: true,
            theme: 'light',
            arrow: true,
        });
    };

    const closeTakeDecision = value => {
        setDecisionsModal(false);
    };

    const printModalTakeDecision = () => {
        if (!decisionsModal) return null;
        return (
            <DealerReceptorDecisions
                history={history}
                closeModal={closeTakeDecision}
            />
        );
    };

    const printPenaltyRows = () => {
        let rows = [];


        if( vehicleParent.AutoCredit===0){ 
        if (
            vehicleParent.RepurchaseObligation === 1 &&
            vehicleParent.IsReturnDealerPromoter == 1
        ) {
            rows.push(
                <div
                    key={`${vehicleParent.Id}-irrevocable-key`}
                    className="u-1/1"
                >
                    <p className="u-h6 u-text-alert">
                        {t.getTraduction('Irrevocable')}
                    </p>
                </div>
            );
        } else if (
            vehicleParent.RepurchaseObligation === 0 &&
            vehicleParent.AcceptedWithReport == 1 &&
            vehicleParent.IsReturnDealerPromoter == 1
        ) {
            rows.push(
                <div key={`${vehicleParent.Id}-penalty-key`} className="u-1/1">
                    <p className="u-mb-xsmall">
                        {t.getTraduction('PenaltyForDismissal')}
                    </p>
                    <p className="u-h6 u-text-alert">
                        {formatPrice(vehicleParent.RepurchaseObligationPrice)}
                    </p>
                </div>
            );
        } else if (
            (vehicleParent.RepurchaseObligation === 0 &&
                vehicleParent.AcceptedWithReport == 0) ||
            (vehicleParent.AcceptedWithReport == 0 &&
                vehicleParent.IsReturnDealerPromoter == 0)
        ) {
            rows.push(
                <div key={`${vehicleParent.Id}-penalty-key`} className="u-1/1">
                    <p className="u-mb-xsmall">
                        {t.getTraduction('WithourReport')}
                    </p>
                    <p
                        className="u-mb-xsmall u-text-alert"
                        title={t.getTraduction('DismissalWithourReport_Full')}
                    >
                        {t.getTraduction('DismissalWithourReport')}
                    </p>
                </div>
            );
        }
    }
    else
    {
        if (
            (vehicleParent.AcceptedWithReport === 0)
        ) {
            rows.push(
                <div key={`${vehicleParent.Id}-penalty-key`} className="u-1/1">
                    <p className="u-mb-xsmall">
                        {t.getTraduction('WithourReport')}
                    </p>
                    <p
                        className="u-mb-xsmall u-text-alert"
                        title={t.getTraduction('DismissalWithourReport_Full')}
                    >
                        {t.getTraduction('DismissalWithourReport')}
                    </p>
                </div>
            );
        }
        if (
            (vehicleParent.AcceptedWithReport === 1 && !vehicleParent.PhysicalClient && !vehicleParent.InvoiceClientDealerUploaded)
        ) {
            rows.push(
                <div key={`${vehicleParent.Id}-invoice-key`} className="u-1/1">
                    <p className="u-mb-xsmall">
                    {t.getTraduction('InvoiceForDismissalAutocredit')}
                    </p>
                    <p
                        className="u-mb-xsmall u-text-alert"
                        title={t.getTraduction('DismissalWithoutInvoice_Full')}
                    >
                         {t.getTraduction('DismissalWithoutInvoice')}                        
                    </p>
                </div>
            );
        }
    }

        return rows;
    };

    return (
        <Fragment>
            <div className={isDetailView ? 'u-mv u-pr' : ''}>
                {printPenaltyRows()}
                <div className={isDetailView ? 'u-mb' : 'u-1/1'}>
                    <p className="u-mb-xsmall">
                        {t.getTraduction('AmountOfTheVehicle')}
                    </p>
                    <p className="u-h5">{formatPrice(vehicleParent.Price)}</p>
                </div>
                {vehicleParent.ImporteIncentivoRecompraAC && vehicleParent.ImporteIncentivoRecompraAC > 1 ? (
                    <div className={isDetailView ? 'u-mb' : 'u-1/1'}>
                        <p className="u-mb-xsmall">
                            {t.getTraduction('ImporteIncentivoRecompra')}
                        </p>
                        <p className="u-h5 u-text-success">
                            {new Intl.NumberFormat('ca', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(vehicleParent.ImporteIncentivoRecompraAC)}
                            {' '}<small style={{ fontSize: '0.7em' }}>(iva incluido)</small>
                        </p>
                    </div>
                ) : null}
                <div className={isDetailView ? 'u-mb' : 'u-1/1'}>
                    {printButton()}
                </div>
            </div>
            {printModalTakeDecision()}
        </Fragment>
    );
};

export default withCookies(VehicleDealerReceptorModality);
